import { LogoOption } from '../types';
import { fetchWithErrorHandling } from './apiUtils';

export class LogoService {
  static async getLogoOptions(productId: number, color?: string | null): Promise<LogoOption[]> {
    try {
      const params = color ? `?color=${encodeURIComponent(color)}` : '';
      return await fetchWithErrorHandling<LogoOption[]>(`/api/v2/products/${productId}/logo-options${params}`);
    } catch (error) {
      console.error('Failed to fetch logo options:', error);
      return [];
    }
  }
}
